/**
 * @module
 */

/**
 * If a Decision cannot be made for some reason, this error should be thrown.
 *
 * @typedef {Error} DecisionError
 */

function DecisionError(msg){
  this.message = msg;
}

DecisionError.prototype = new Error();

exports.DecisionError = DecisionError;


